import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import RaisedButton from 'material-ui/RaisedButton';
import { deleteAgencyData, getAgencyList } from '../actions/AgencyAction';
import Alert from 'react-s-alert';
import PaginatorCustom from '../../../../../components/paginationCustom';
import { Field, reduxForm, reset } from 'redux-form';
import { renderTextField } from '../../../../../components/reduxFields';
import { NavLink } from 'react-router-dom';
// import { extractNameFromArray } from '../../../../../actions/utilAction';
import SortingCustom from '../../../../../components/SortingCustom';
import { resetFiltersAndSorting, showFormatedDate } from '../../../../../actions/utilAction';


class AgencyListing extends Component {

  constructor(props) {
    super(props);

    this.filter = {
      sortColumn: '',
      sortOrder: '',
      searchTextByAgencyName: null,
      searchTextByBusinessName: null,
    };

    this.handleSearchAgencyByNameAndLocation = this.handleSearchAgencyByNameAndLocation.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
  }

  loadData(pageNumber) {
    let searchObj = {
      sort_fields: this.filter.sortColumn ? this.filter.sortColumn : '',
      sort_order: this.filter.sortOrder ? this.filter.sortOrder : '',
      contain_filters: {
        orgName: this.filter.searchTextByAgencyName ? this.filter.searchTextByAgencyName : '',
        businessName: this.filter.searchTextByBusinessName ? this.filter.searchTextByBusinessName : '',
      },
      pageNumber: pageNumber ? pageNumber : 1,      
      pageSize: 50,
    };
    // console.log('searchObj........',searchObj)
    this.props.getAgencyList(searchObj);
  }

  // loadData(page_number) {
  //   let customSearch = `?page_size=${GlobalVariables.PageSize}&page_number=${page_number ? page_number : 1}`;
  //   customSearch = customSearch + `&sort_fields=${this.filter.sort_Column}`;
  //   customSearch = customSearch + `&orgName=${this.filter.searchTextByAgencyName ? this.filter.searchTextByAgencyName : ''}&businessName=${this.filter.searchTextByBusinessName ? this.filter.searchTextByBusinessName : ''}`;
  //   this.props.getAgencyList(customSearch);
  // }

  componentWillMount() {
    // this.props.getMasterData();
    this.loadData();
  }
  componentWillReceiveProps(nextProps) {
    // console.log(nextProps);
  }

  handleEditClick=(event, obj) => {
    this.setState({ agencyData: obj, agencyId: obj.id });
  }

  handleAlertClick=(event, serviceCode) => {

    // this.props.deleteServiceCode(serviceCode);
    Alert.closeAll();
  }

  handleDeleteClick=(event, obj) => {
    Alert.warning('Are you sure you want to delete agency details?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  }

  handleSearchAgencyByNameAndLocation(event) {
    // event.preventDefault();
    //  console.log('agency search............', event);

    if (event.AgencyName !== undefined || event.businessName !== undefined) {

      this.filter.searchTextByAgencyName = event.AgencyName;
      this.filter.searchTextByBusinessName = event.businessName;
      this.loadData();
    }
  }

  handleReset() {
    this.filter.searchTextByAgencyName = '';
    this.filter.searchTextByBusinessName = '';
    Alert.closeAll();
    this.props.dispatch(reset('AgencyListingForm'));
    resetFiltersAndSorting(this.filter, 'id', false);
    this.loadData();
  }

  handleSearchChange(event, text) {
    //  console.log(event, text);
    if (!text.trim()) {
      if (event.target.name === 'AgencyName') {
        this.filter.searchTextByAgencyName = '';
      } else {
        this.filter.searchTextByBusinessName = '';
      }
      if (!this.filter.searchTextByAgencyName && !this.filter.searchTextByBusinessName) {
        this.loadData();
      }
    }
  }

  setSortColumn(sortColumn, sortOrder) {
    if (sortColumn) {
      this.filter.sortColumn = sortColumn;
      this.filter.sortOrder = sortOrder;

      this.loadData();
    }
  }

  renderData() {
    if (!this.props.agencyList || !this.props.agencyList.data || this.props.agencyList.data.length === 0) {
      return (
        <tr>
          <td colSpan="4">
            <div className="familydl text-center no-record">No record found.</div>
          </td>
        </tr>
      );
    }
    // console.log(typeof this.props.agencyList.data);
    return this.props.agencyList.data.map((data, index) => {

      return (
        <tr key={index}>
          <td>{data.organizationName}</td>
          <td>{data.businessName}</td>
          <td>{data.address}</td>
          <td>{data.planName}</td>
          <td>{showFormatedDate(data.startDate)}</td>
          <td>
            <NavLink to={`/webadmin/agency-setup/${data.organizationID}`}className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></NavLink>
            {/* <button onClick={(e) => this.handleDeleteClick(e, data)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>*/}
          </td>
        </tr>
      );
    });
  }

  render() {
    // console.log('agencyList render().......', this.props.agencyList);
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });


    return (
      <div>
        <h2 className="page_title">Manage Agency</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="readmin-form">
              <div className="row">
                <div className="col-sm-4">
                  <RaisedButton label="Add Agency" primary={true} containerElement= {<NavLink to={'/webadmin/agency-setup'} />}/>
                </div>
                <div className="col-sm-8">
                  <form onSubmit={handleSubmit(this.handleSearchAgencyByNameAndLocation)}>
                    <div className="row end-flex">
                      <div className="col-sm-4 mtm-27">
                        <Field
                          name="AgencyName"
                          maxLength = '15'
                          floatingLabelText="Agency Name"
                          component={renderTextField}
                        />
                      </div>
                      <div className="col-sm-4 mtm-27">
                        <Field
                          name="businessName"
                          floatingLabelText="Business Name"
                          component={renderTextField}
                        />
                      </div>
                      <div className="col-sm-4 btn_rt reset-btn">
                        <RaisedButton className="grey_btn" type="Submit">Filter</RaisedButton>
                        <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="table-responsive mt-15">
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          {this.props.agencyList && this.props.agencyList.data && this.props.agencyList.data.length ?
                            (<th width="25%"><SortingCustom setSortColumn={this.setSortColumn} columnName='organizationname' displayName='Agency Name'/></th>)
                            : (<th width="25%">Agency Name</th>) }
                          {this.props.agencyList && this.props.agencyList.data && this.props.agencyList.data.length ?
                            (<th width="15%"><SortingCustom setSortColumn={this.setSortColumn} columnName='businessName' displayName='Business Name'/></th>)
                            : (<th width="15%">Business Name</th>) }
                          <th width="30%"><span>Address</span></th>
                          <th width="10%"><span>Plan Name</span></th>
                          <th width="15%"><span>Start Date</span></th>
                          <th width="5%">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderData()}
                      </tbody>
                    </table>
                    {/* :
                     <table className={tableClass}>
                       <thead>
                         <tr>
                           <th width="30%"><span>Agency Name</span></th>
                           <th width="30%"><span>Location Name</span></th>
                           <th width="20%"><span>Status</span></th>
                           <th width="20%">Action</th>
                         </tr>
                       </thead>
                       <tbody>
                         <tr>
                           <td colSpan="4">
                             <div className="familydl">No record found.</div>
                           </td>
                         </tr>
                       </tbody>
                     </table>
                     : null}*/}
                    {this.props.agencyList && this.props.agencyList.data && this.props.agencyList.data.length ?
                      <PaginatorCustom data={this.props.agencyList.meta} handlePageChange={(page_number) => this.loadData(page_number)} />
                      : null }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AgencyListing = reduxForm({
  form: 'AgencyListingForm',
})(AgencyListing);
function mapStateToProps(state) {
  // console.log('state.agency.agencyList.........',state.agency.agencyList);
  return {
    // master_data: state.agency.master_data,
    agencyList: state.agency.agencyList,
  };
}

export default connect(mapStateToProps, { getAgencyList, deleteAgencyData })(AgencyListing);



// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/ManageAgency/components/index.js